module.exports = __webpack_public_path__ + "res/4-img_business_bg.d305ea16d038b0aec877b9d35f13cb30.png";